<div class="content">
  @switch (country) {
    @case ('nl') {
      <h4 class="text-title">{{ 'GDPR.LegalNote' | translate }}</h4>
      <p class="text">
        Hierbij verklaar ik dat deze persoon heeft bevestigd dat hij/zij door
        Verisure benaderd wil worden voor het verkrijgen van informatie over de
        Verisure alarmdiensten. Ik verklaar dat ik deze persoon heb geïnformeerd
        dat Verisure de contactgegevens zal gebruiken om telefonisch, per
        whatsapp en per SMS contact op te nemen voor het geven van informatie
        over onze alarmdiensten, het maken van een afspraak en het starten van
        de offerte aanvraag.
      </p>
      <div class="action-panel">
        <span
          >Ik heb deze persoon verwezen naar onze
          <a
            href="https://www.verisure.nl/privacy-en-cookie-verklaring"
            target="_blank"
            >privacyverklaring</a
          >
          op Verisure.nl voor meer informatie over hoe Verisure de
          contactgegevens gebruikt.</span
        >
        <p-toggleswitch
          class="switch"
          test-id="toggle-gdpr"
          [(ngModel)]="checked"
        ></p-toggleswitch>
      </div>
    }
    @default {
      No GDPR text available
    }
  }
</div>

<button
  pButton
  [label]="'Globals.Continue' | translate"
  class="hoverable-button p-button-raised p-button-sm"
  (click)="accept()"
  [disabled]="!checked"
  test-id="btn-accept-gdpr"
></button>
